import React from 'react';
import * as R from 'ramda';
import {FormLabel} from 'js/form_components';
import TagsInput from 'react-tagsinput';

const InputTags = props => {
    const inputProps = {
        className: 'react-tagsinput-input',
        name: props.key
    };

    return (
        <div className="form-group">
            <FormLabel
                className={props.className}
                label={props.header}
                helpText={props.help}
                multiline
                inline
                place="right"
            />
            <TagsInput
                inputProps={inputProps}
                value={props.value}
                onChange={R.pipe(
                    R.join(','),
                    props.onChange
                )}
                renderTag={props => {
                    const {tag, key, onRemove} = props;
                    return (
                        <div key={key} className="Select-item">
                            <span onClick={e => onRemove(key)} className="Select-item-icon">
                                x
                            </span>
                            <span className="Select-item-label">{tag}</span>
                        </div>
                    );
                }}
            />
        </div>
    );
};

export default InputTags;



// WEBPACK FOOTER //
// ./publisher_leads/advanced_filters/input_tags.js